/**
 * Teatro activo expuesto en el DOM.
 *
 * Deja el hash del teatro en `<html data-teatro="...">` para que una hoja de estilos pueda
 * acotar una regla a un cliente concreto. Es el caso de las cuatro zonas del Estadio
 * Enrique Roca (Real Murcia) que se iluminan en morado al pasar el ratón: la regla vive en
 * public/css/main2.css y su test en tests/unit/main2-zone-hover-colors.spec.js.
 *
 * El valor es el mismo hash que la app manda a la API como `hash_teatro` (el que AppLoader
 * lee de la configuración del sitio), de modo que la regla solo se aplica cuando quien
 * navega está en ese teatro.
 */

/**
 * Escribe (o borra) el teatro activo en el elemento raíz del documento.
 *
 * @param {string|null|undefined} hashTeatro Hash del teatro; si falta, se borra el atributo.
 * @param {Document} [doc] Documento donde escribir. Inyectable para los tests.
 */
export function setTeatroScope(hashTeatro, doc) {
    const target = doc || (typeof document !== 'undefined' ? document : null);

    if (!target || !target.documentElement) {
        return;
    }

    if (hashTeatro) {
        target.documentElement.setAttribute('data-teatro', String(hashTeatro));
    } else {
        target.documentElement.removeAttribute('data-teatro');
    }
}
